<!-- eslint-disable vue/prop-name-casing -->
<script setup>
import { nextTick } from 'vue';
import { $toast } from '~/common/utils/common.utils';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['close', 'save']);

const $t = inject('$t');
const views = [
  {
    uid: 'basic',
    tooltip_text: $t('Basic'),
    action: 'basic',
    label: $t('Basic'),

  },
  {
    uid: 'advanced',
    tooltip_text: $t('Advanced'),
    action: 'advanced',
    label: $t('Advanced'),

  },
];

const active_item = ref(props.data?.active_tab ? views.find(v => v.uid === props.data.active_tab) : views[0]);
const unpivot_data = ref(props.data ? { data: props.data } : null);
const is_preview = ref(false);
const advanced_view = ref(null);

function next() {
  if (active_item.value.uid === 'advanced') {
    nextTick(async () => {
      const result = await advanced_view.value.onSelection();
      is_preview.value = result;
    });
  }
  else {
    const { types } = unpivot_data.value;
    if (types.length > 1) {
      return $toast({ title: 'Please select columns of the same type', type: 'error' });
    }

    is_preview.value = true;
  }
}

function apply() {
  const { data } = unpivot_data.value;
  data.active_tab = active_item.value.uid;
  emit('save', data);
}
</script>

<template>
  <HawkModalTemplate class="!z-[1010]" @close="emit('close')">
    <template #header>
      <div class="flex items-center justify-between p-4">
        <div class="text-lg font-semibold">
          {{ $t('Unpivot results') }}
        </div>
        <div class="text-gray-600 rounded-md hover:bg-gray-50 cursor-pointer flex justify-center items-center p-2 ml-2" @click="emit('close')">
          <IconHawkXClose />
        </div>
      </div>
      <hr>
    </template>
    <div class="flex flex-col justify-between w-[1200px] max-h-[calc(100vh-200px)] overflow-auto scrollbar -m-6 p-6">
      <hawk-button-group
        v-if="!is_preview"
        icon
        size="md"
        class="mr-2"
        :items="views"
        :active_item="active_item.uid"
        @basic="active_item = views[0];unpivot_data = null"
        @advanced="active_item = views[1];unpivot_data = null"
      />
      <bi-unpivot-basic v-if="active_item.uid === 'basic'" v-model="unpivot_data" :is-preview="is_preview" @back="is_preview = false;" />
      <bi-unpivot-advanced v-if="active_item.uid === 'advanced'" ref="advanced_view" v-model="unpivot_data" :is-preview="is_preview" @back="is_preview = false" />
    </div>
    <template #footer>
      <div class="justify-end flex">
        <HawkButton type="outlined" class="mr-2" @click="emit('close')">
          {{ $t('Cancel') }}
        </HawkButton>
        <HawkButton v-if="is_preview" @click="apply">
          {{ $t('Apply') }}
        </HawkButton>
        <HawkButton v-else :disabled="active_item.uid === 'basic' && !unpivot_data?.types?.length" @click="next">
          {{ $t('Next') }}
        </HawkButton>
      </div>
    </template>
  </HawkModalTemplate>
</template>
